import React from 'react'
import BasePage from "Base/Page"

class Home extends BasePage {
    constructor(props) {
        super(props)
    }

    render() {
        return (
<div className="main_container">
<div className="card fluid">
    <div className="section">
        <h3>who am I</h3>
        <p>Emil Perhinschi</p>
    </div>

    <div className="section">
        <h3>how old</h3>
        <p>born in 1975</p>
    </div>

    <div className="section">
    <h3>where have I lived</h3>
    <ul>
        <li>Bucharest, Romania, June 2018 until now: writing APIs, sort of restfull but more aking to RPC over HTTP </li>
        <li>Suceava, Romania, November 2017 - June 2018: freelancing, mostly blockchain related</li>
        <li>London, UK, 2016-2017: system developer</li>
        <li>Cluj-Napoca, Romania, 2012-2016: Perl developer</li>
        <li>Iaşi, România, 2009-2012: Perl developer</li>
        <li>Bucureşti, România, 1993-2009: student, librarian, research
        assistant, software developer</li>
    </ul>
    </div>

    <div className="section">
    <h3>experience </h3>
    <ul>
    <li>data processing and web applications with Perl: since 1999</li>
    <li>data processing and web applications with Java, PHP (versions 3,4,5):
     occasionaly</li>
    <li>data processsing and web services with Node: recent</li>
    <li>data processsing and web services with D v2: recent</li>
    <li>Linux devOps: from building custom kernels to building custom Docker
    images and training users: since 1999</li>
    <li>MySQL, Postgres, DB2 and MongoDB development, configuration,
     optimization</li>
    <li>web services written in C# on windows</li>
    </ul>
    </div>

    <div className="section">
    <h3>prefered development environment</h3>
    GNU
    </div>

    <div className="section">
    <h3>also dabbled in</h3>
    <ul>
        <li>desktop apps
            <ul>
            <li>Gtk + Dlang</li>
            <li>Perl + Gtk and Gtk2</li>
            <li>Java + SWT</li>
            <li>NWJS</li>
            </ul>
        </li>
        <li>web UIs
            <ul>
            <li>React</li>
            <li>jQuery</li>
            <li>Bootstrap</li>
            </ul>
        </li>
        <li>languages
            <ul>
            <li>Python: debugged, fixed apps written by others</li>
            <li>C: used with Perl XS and imported libraries for use in Dlang</li>
            </ul>
        </li>
    </ul>
    </div>

    <div className="section">
    <h3>site powered by</h3>
    <p>electricity</p>
    </div>
</div>
</div>
        )
    }
}

export default Home



// WEBPACK FOOTER //
// ./src/lib/components/site/pages/Home.js